/* unplugin-vue-components disabled */var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-img",
        {
          staticClass: "px-4",
          attrs: {
            height: _vm.height,
            src: "src/images/parallax/contact.webp",
            gradient: "to top right, rgba(0,0,0,.45), rgba(0,0,0,.2)",
            flat: "",
            dark: "",
            tile: "",
          },
        },
        [
          _c(
            "v-row",
            {
              staticClass: "ma-0 fill-height text-center boas",
              attrs: { align: "center", justify: "center" },
            },
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c("h1", [_vm._v("Formulário de Contato")]),
                _vm._v(" "),
                _c("p", [_vm._v("Entre em contato conosco")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-container", [
        _c(
          "div",
          { staticClass: "mt-4 mb-8 py-3 mx-4" },
          [
            _c(
              "v-form",
              {
                ref: "form",
                attrs: { id: "form-contact", "lazy-validation": _vm.lazy },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.validate.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.valid,
                  callback: function ($$v) {
                    _vm.valid = $$v
                  },
                  expression: "valid",
                },
              },
              [
                _c("v-text-field", {
                  attrs: {
                    color: "info",
                    outlined: "",
                    dense: "",
                    rules: _vm.rules.name,
                    label: "Nome",
                    placeholder: "Seu nome",
                  },
                  model: {
                    value: _vm.form.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "name", $$v)
                    },
                    expression: "form.name",
                  },
                }),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: {
                    color: "info",
                    outlined: "",
                    dense: "",
                    rules: _vm.rules.email,
                    label: "E-mail",
                    placeholder: "Seu email",
                  },
                  model: {
                    value: _vm.form.email,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "email", $$v)
                    },
                    expression: "form.email",
                  },
                }),
                _vm._v(" "),
                _c("v-textarea", {
                  attrs: {
                    color: "info",
                    outlined: "",
                    rules: _vm.rules.message,
                    label: "Mensagem",
                    placeholder: "Sua mensagem",
                  },
                  model: {
                    value: _vm.form.message,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "message", $$v)
                    },
                    expression: "form.message",
                  },
                }),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "mr-4",
                    attrs: {
                      form: "form-contact",
                      type: "submit",
                      title: "enviar email",
                      block: "",
                      dark: "",
                      color: "error darken-1",
                    },
                  },
                  [_vm._v("\n          enviar\n        ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }